module.exports = __webpack_public_path__ + "media/images/ping/ping_celeste-10caf4bf9bd701c9e26cb712012a43f0.svg";